import { cn } from "@/lib/utils";

interface PercentageButtonProps {
  onClick: (e: React.MouseEvent) => void;
  children: React.ReactNode;
}

export default function PercentageButton({
  onClick,
  children,
}: PercentageButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "px-3 py-1 text-xs rounded-md transition-colors",
        "bg-muted/30 hover:bg-muted/50 text-muted-foreground/90",
        "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1"
      )}
    >
      {children}
    </button>
  );
}
